import { render } from "./StandardInput.vue?vue&type=template&id=2d018dea&scoped=true"
import script from "./StandardInput.vue?vue&type=script&lang=js"
export * from "./StandardInput.vue?vue&type=script&lang=js"

import "./StandardInput.vue?vue&type=style&index=0&id=2d018dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d018dea"]])

export default __exports__